var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col space-x-8 mb-2",
    class: _vm.$attrs.class
  }, [_c('div', {
    staticClass: "flex flex-row space-x-2 items-center"
  }, [_vm.type === 'checkbox' && _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.innerValue,
      expression: "innerValue"
    }],
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.data,
      "checked": Array.isArray(_vm.innerValue) ? _vm._i(_vm.innerValue, _vm.data) > -1 : _vm.innerValue
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.innerValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = _vm.data,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.innerValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.innerValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.innerValue = $$c;
        }
      }
    }
  }) : _vm.type === 'radio' && _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.innerValue,
      expression: "innerValue"
    }],
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "type": "radio"
    },
    domProps: {
      "value": _vm.data,
      "checked": _vm._q(_vm.innerValue, _vm.data)
    },
    on: {
      "change": function ($event) {
        _vm.innerValue = _vm.data;
      }
    }
  }) : _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.innerValue,
      expression: "innerValue"
    }],
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "type": _vm.type
    },
    domProps: {
      "value": _vm.data,
      "value": _vm.innerValue
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.innerValue = $event.target.value;
      }
    }
  }) : _vm.type === 'checkbox' ? _c('label', {
    staticClass: "custom-checkbox"
  }, [_c('input', {
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.data,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.toggleValue
    }
  }), _c('span', {
    staticClass: "checkmark",
    class: _vm.checkMarkClass
  })]) : _vm._e(), _c('label', {
    staticClass: "block text-base font-light",
    class: _vm.labelClass,
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }